import {
    IonAvatar,
    IonCol, 
    IonIcon,
    IonImg,
    IonItem,
    IonLabel,
    IonNote,
    IonRow,
    IonThumbnail,
    IonButton
} from '@ionic/react';
import { closeCircleOutline, image, arrowForwardCircleOutline } from 'ionicons/icons';
import { Beneficiary } from '../data/beneficiaries';

  import React, { Component }  from 'react';

interface BeneficiaryListItemProps {   
    beneficiary: Beneficiary;
    onClick : any;
}

const BlockUserItem: React.FC<BeneficiaryListItemProps> = ({ beneficiary, onClick }) => {
    return (
        <IonItem onClick={()=> {onClick(beneficiary.id)}} lines="none" >
            <IonAvatar slot="start">
                <img src={beneficiary.avatar} onError={ ({currentTarget}) => { currentTarget.src = 'assets/img/avt.jpg' } } />
            </IonAvatar>
            <IonLabel className="ion-text-wrap">
                <h2>{beneficiary.displayName}</h2>
                <IonNote>{beneficiary.email}</IonNote>
            </IonLabel>
            <IonIcon slot="end" icon={closeCircleOutline} size="large" />
        </IonItem>
    );
};

export default BlockUserItem;